var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('va-inner-loading',{attrs:{"loading":_vm.loading}},[_c('reviews-table',{staticClass:"mb-4",attrs:{"reviews":_vm.reviews,"loading":_vm.loading},on:{"refresh":_vm.fetchReviews}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }